import React from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const useInsurerList = (insurer) => {
  const {
    ac_number,
    name,
    orias_number,
    address,
    phone_number,
    email,
    owner_gender,
    owner_first_name,
    owner_last_name,
    owner_mobile_number,
    owner_phone_number,
    owner_email,
    iban,
    bic,
    quote_automail,
    group,
    group_membership_date
  } = insurer;

  const { t } = useTranslation();

  const infoBrokerFirm = [
    {
      label: 'insurers.form.ac_number',
      span: 1,
      content: ac_number || '-'
    },
    {
      label: 'insurers.form.name',
      span: 1,
      content: name || '-'
    },
    {
      label: 'insurers.form.orias_number',
      span: 1,
      content: orias_number || '-'
    },
    {
      label: 'insurers.form.address_full',
      span: 1,
      content: address ? (
        <>
          {`${address.number} ${address.street}`}
          <br />
          {address.additional}
          {address.additional && <br />}
          {`${address.postal_code} ${address.city}`}
        </>
      ) : (
        '-'
      )
    },
    {
      label: 'insurers.form.phone_number',
      span: 1,
      content: phone_number || '-'
    },
    {
      label: 'insurers.form.email',
      span: 3,
      content: email || '-'
    }
  ];

  const infoOwner = [
    {
      label: 'insurers.form.owner_gender',
      span: 1,
      content: `${owner_gender === 'MISTER' ? 'Monsieur' : 'Madame'}`
    },
    {
      label: 'insurers.form.owner_first_name',
      span: 1,
      content: owner_first_name || '-'
    },
    {
      label: 'insurers.form.owner_last_name',
      span: 1,
      content: owner_last_name || '-'
    },
    {
      label: 'insurers.form.owner_mobile_number',
      span: 1,
      content: owner_mobile_number || '-'
    },
    {
      label: 'insurers.form.owner_phone_number',
      span: 1,
      content: owner_phone_number || '-'
    },
    {
      label: 'insurers.form.owner_email',
      span: 1,
      content: owner_email || '-'
    },

    {
      label: 'insurers.form.iban',
      span: 1,
      content:
        (
          <Tooltip title="pour modifier l'IBAN veuillez envoyer le nouveau RIB à courtage@assurmaxpro.com">
            <span>{iban}</span>
          </Tooltip>
        ) || '-'
    },
    {
      label: 'insurers.form.bic',
      span: 1,
      content:
        (
          <Tooltip title="pour modifier le BIC veuillez envoyer le nouveau RIB à courtage@assurmaxpro.com">
            <span>{bic}</span>
          </Tooltip>
        ) || '-'
    },
    {
      label: 'insurers.form.quote_automail',
      span: 1,
      content: t(`quotes.form.switch.${quote_automail}`)
    }
  ];

  const infoGroup = [
    {
      label: 'insurers.form.group',
      span: 1,
      content: group?.name || '—'
    },
    {
      label: 'insurers.form.group_membership_date',
      span: 1,
      content: group_membership_date ? moment(group_membership_date).format('MM/YYYY') : '—'
    },
    {
      label: 'insurers.form.group_head',
      span: 1,
      content: group?.head_insurer?.name || '—'
    }
  ];

  return { infoBrokerFirm, infoOwner, infoGroup };
};

export default useInsurerList;
